(function () {
  function initFaqSplit(root) {
    if (root.dataset.fsqReady === 'true') return;
    root.dataset.fsqReady = 'true';

    var singleOpen = root.dataset.singleOpen === 'true';
    root.querySelectorAll('[data-fsq-item]').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!singleOpen || !item.open) return;
        root.querySelectorAll('[data-fsq-item]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-faq-split]').forEach(initFaqSplit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-faq-split]');
    if (root) initFaqSplit(root);
  });
})();
